import { Button, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import * as React from "react";
import { useGameContext } from "../../../GameContext/GameContext";
import { OriginalGameState } from "../../../GameContext/OriginalGameState";
import * as ThemeConstants from "../../../../Styles/Constants";
import { useWindowDimensions } from "../../UseWindowDimensions";
import { LetterGrid } from "../LetterGrid";
import TimerIcon from '@material-ui/icons/Timer';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
            textAlign: "center"
        },
        textFlex: {
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            gap: "0.5rem"
        },
        resultsPlayerCol: {
            paddingLeft: "1rem",
            paddingRight: "1rem",
            textAlign: "left",
            minWidth: 200
        }
    })
);

export const OriginalGameResultsList = () => {
    const classes = useStyles();
    const { width, height } = useWindowDimensions();
    const gameContext = useGameContext();

    const { actualLocalPlayer, gameResults } = gameContext.gameState as OriginalGameState;

    const returnToLobby = () => {
        gameContext.updateGameState((prevState: OriginalGameState) => {
            return {
                ...prevState,
                gameStarted: false,
                gameResults: null,
                lobbyOpen: true
            }
        });
    }

    return (
        <div className={classes.root}>
            <Typography variant="h3">GAME OVER</Typography>
            {actualLocalPlayer?.startedAsPlayer &&
                ((actualLocalPlayer && gameResults?.players.find((e) => e.playerId == actualLocalPlayer.id)) ?
                    <Typography variant="h5" style={{ marginTop: "-1rem" }} color="textSecondary">{`You placed #${gameResults.players.findIndex((e) => e.playerId == actualLocalPlayer.id) + 1}`}</Typography>
                    :
                    <Typography variant="h5" style={{ marginTop: "-1rem" }} color="textSecondary">{`You did not place on the leaderboard`}</Typography>
                )
            }
            <Button onClick={returnToLobby} color="secondary" variant="contained">
                Back to Room
                    </Button>
            <div id="resultsScroll" style={{ overflowX: "auto", maxWidth: "100%" }}>
                <table style={{ marginTop: "1rem", borderSpacing: width < 600 ? "0.5rem" : "1rem" }}>
                    <thead>
                        <tr>
                            <th />
                            {
                                gameResults?.words.map((w, i) => {
                                    return (
                                        <th key={i} style={{ minWidth: width < 600 ? 110 : 200 }}>
                                            <Typography variant="h5">{w.toUpperCase()}</Typography>
                                        </th>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            gameResults?.players.map((p, i) => {
                                let bkgColor = "#00000000";
                                switch (i) {
                                    default: break;
                                    case 0: bkgColor = "#ddab0496"; break;
                                    case 1: bkgColor = "#756f5d96"; break;
                                    case 2: bkgColor = "#602c0796"; break;
                                }

                                return (
                                    <tr key={i}>
                                        <td className={classes.resultsPlayerCol} style={{ backgroundColor: bkgColor }}>
                                            <div className={classes.textFlex}>
                                                <Typography variant="body1">{p.playerName}</Typography>
                                                {(p.playerId == actualLocalPlayer?.id) &&
                                                    <Typography variant="body1" style={{ color: ThemeConstants.PALETTE_ORANGE }}>(YOU)</Typography>
                                                }
                                            </div>
                                            <Typography color="textSecondary" variant="body1">Final Score: {p.totalScore}</Typography>
                                            <div className={classes.textFlex}>
                                                <img src="favicon.ico" width={20} />
                                                <Typography color="textSecondary" variant="body1">{p.totalWordScore}</Typography>
                                            </div>
                                            {gameResults.parameters.timeBonusEnabled &&
                                                <div className={classes.textFlex}>
                                                    <TimerIcon fontSize={"small"} />
                                                    <Typography color="textSecondary" variant="body1">{p.timeBonus}</Typography>
                                                </div>
                                            }
                                        </td>
                                        {
                                            p.words.map((w, i) => {
                                                return (
                                                    <td key={i}>
                                                        <LetterGrid
                                                            rows={gameResults.parameters.guessCount}
                                                            cols={gameResults.parameters.wordLength}
                                                            words={w.guesses}
                                                            matches={w.matches}
                                                            size="md"
                                                        />
                                                        <Typography variant="body1">{`${w.score} pts`}<b>{`${w.multiplier > 1 ? ` (X${w.multiplier})` : ""}`}</b></Typography>
                                                    </td>
                                                );
                                            })
                                        }
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}